import { useEffect, useState } from "react"
import { GTIWebButton, Dialog, DialogContent, DialogActions, GTIWebSelect, GTIWebForm } from "@gti-controls-v2/web-core";
import useTranslation from "../../../hooks/useTranslation";
import { useMediaQueryCustom } from "../../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import { localStorageData } from "../../../common/constants/Settings";

export const DialogoSeleccionarCaja = (props) => {

    const { t } = useTranslation();
    const { isMobile480, isTablet768, isTablet1024 } = useMediaQueryCustom();
    const [formData, setFormData] = useState({});

    useEffect(() => {
        //Obtengo el dato de cajaID en localStorage
        const cajaIDLocalStorage = parseInt(localStorage.getItem(localStorageData.CAJA_ID));

        //Si existe el dato de cajaID en localStorage y  es > 0, asigno la caja seleccionada
        if (cajaIDLocalStorage && cajaIDLocalStorage > 0) {
            formData.cajaSeleccionada = cajaIDLocalStorage;
        }
        // eslint-disable-next-line
    }, [])

    const handleSetCaja = (data) => {
        setFormData(data);
        localStorage.setItem(localStorageData.CAJA_ID, data.cajaSeleccionada);
        props.setCaja(data.cajaSeleccionada);
        props.setCajaNombre(getCajaNombre(data.cajaSeleccionada));
        props.setCajaOpen(false);
    };

    const getCajaNombre = (cajaID) => {
        if (props?.cajas) {
            for (const item of props.cajas) {
                if (item.CafeCajaID === cajaID) {
                    if (item.CafeCajaID > 0) {
                        return item.CafeCajaNombre;
                    }
                    else {
                        return "";
                    }
                }
            }
        }
    };

    return (
        <>
            <Dialog
                open={props.cajaOpen}
                fullWidth
                maxWidth="sm"
            >
                <GTIWebForm noValidate onSubmit={handleSetCaja} value={formData}>
                    <DialogContent sx={{ padding: "16px 16px 8px 16px" }}>
                        <GTIWebSelect
                            autoWidth
                            disableDefaultReadOnly
                            name={"cajaSeleccionada"}
                            selectedValue="CafeCajaID"
                            displayedValue="CafeCajaNombre"
                            dataSource={props.cajas}
                            labelText={t("sistema.titulos.estacion")}
                            required={props?.cajas?.length > 1 ? true : false}
                        />
                    </DialogContent>
                    <DialogActions>
                        <GTIWebButton
                            text={t("sistema.acciones.continuar")}
                            sx={
                                {
                                    fontSize: (isMobile480 || isTablet768) ? "14px" : isTablet1024 ? "16px" : "20px",
                                    height: (isMobile480 || isTablet768 || isTablet1024) ? "32px" : "43px",
                                    marginRight: "8px",
                                    marginBottom: "8px"
                                }
                            }
                            type={"submit"} />
                    </DialogActions>
                </GTIWebForm>
            </Dialog>
        </>
    )
}
